import { PaginatedDataDTO, PaginationDTO } from '@bottega52/commons-pagination';
import { WithStyles, createStyles, withStyles } from '@material-ui/core/styles';
import { Cast, Share } from "@material-ui/icons";
import _ from 'lodash';
import * as React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { IGatewayDeploymentStatusInDTO } from '../../repository/jago/model/input/IGatewayDeploymentStatusInDTO';
import ListEmptyView from "../ListEmptyView";
import DeploymentStatusRow from './DeploymentStatusRow';

const styles = createStyles({
  rowContainer: {
    display: 'flex',
    margin: 10,
    flexDirection: 'column'
  },
  rowBodyContainer: {
    padding: 15,
    minHeight: 100,
  },
  rowTitle: {
    fontWeight: 'bold'
  },
  logo: {
    width: '20%',
  },
});

export interface IDeploymentStatusListProps extends WithStyles<typeof styles>{
  deploymentGateways: PaginatedDataDTO<IGatewayDeploymentStatusInDTO>;
  onFetchMoreItems: (page: number) => void;
}

class DeploymentStatusList extends React.Component<IDeploymentStatusListProps, any> {

  public render() {
    const { deploymentGateways, onFetchMoreItems } = this.props;
    
    const deploymentsData = deploymentGateways && deploymentGateways.content;
    const deploymentsPagination = !_.isEmpty(deploymentGateways) && (deploymentGateways.pagination) ? (deploymentGateways.pagination as PaginationDTO) : null;
    const currentPage = deploymentsPagination ? deploymentsPagination.number : 0;
    const isLastPage = deploymentsPagination ? deploymentsPagination.last : true;
    return (
      <div style={{ zIndex: 100 }}>
        {!deploymentGateways || (deploymentGateways && deploymentGateways.content && _.isEmpty(deploymentGateways.content)) ? (
          <ListEmptyView
            icon={<Cast style={{ fontSize: 40 }} />}
            titleKeyMessage="gateways.noDeploymentDetailedFound"
            descriptionKeyMessage="gateways.noDeploymentDetailedFoundDescription"
          />
        ): (
          <div>
          <InfiniteScroll
            dataLength={_.size(deploymentsData)} //This is important field to render the next data
            next={() => onFetchMoreItems(currentPage + 1)}
            hasMore={!isLastPage}
            loader={<h4>Loading...</h4>}
          >
            {_.map(deploymentsData, deployment => (
              <DeploymentStatusRow key={deployment.id} deploymentGateway={deployment} />
            ))}
          </InfiniteScroll>
          </div>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(DeploymentStatusList);